var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.safeSrc)?_c('audio',{key:_vm.safeSrc,attrs:{"src":_vm.safeSrc,"controls":"","preload":"none"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }